<div class="container-fluid">
	<h2>{{'charger_manufacturers.title' | translate}}</h2>

	<ul class="nav nav-tabs mb-3">
		<li class="nav-item">
			<a class="nav-link pointer" [class.active]="activeTab === 'manufacturers'" (click)="switchTab('manufacturers')">
				{{'charger_manufacturers.manufacturer_list' | translate}}
			</a>
		</li>
		<li class="nav-item">
			<a class="nav-link pointer" [class.active]="activeTab === 'corrections'" (click)="switchTab('corrections')">
				{{'charger_manufacturers.auto_correction' | translate}}
			</a>
		</li>
	</ul>

	<div *ngIf="activeTab === 'manufacturers'">
		<button *ngIf="hasWriteAccess" type="button" class="btn btn-primary mb-3" (click)="openManufacturerModal()">
			{{'charger_manufacturers.add_manufacturer' | translate}}
			<i class="fa fa-plus ml-1"></i>
		</button>

		<sct-custom-table
			*ngIf="manufacturersTableData.length > 0"
			[data]="manufacturersTableData"
			[columnsConfig]="manufacturersColumns"
			[config]="tableConfig">
		</sct-custom-table>

		<div *ngIf="manufacturersTableData.length === 0" class="alert alert-info">
			{{'g.no_data_to_show' | translate}}
		</div>
	</div>

	<div *ngIf="activeTab === 'corrections'">
		<button *ngIf="hasWriteAccess" type="button" class="btn btn-primary mb-3" (click)="openCorrectionModal()">
			{{'charger_manufacturers.add_correction' | translate}}
			<i class="fa fa-plus ml-1"></i>
		</button>

		<sct-custom-table
			*ngIf="correctionsTableData.length > 0"
			[data]="correctionsTableData"
			[columnsConfig]="correctionsColumns"
			[config]="tableConfig">
		</sct-custom-table>

		<div *ngIf="correctionsTableData.length === 0" class="alert alert-info">
			{{'g.no_data_to_show' | translate}}
		</div>
	</div>
</div>

<app-modal
	#manufacturerModal
	[title]="(editedManufacturer.id ? 'charger_manufacturers.edit_manufacturer' : 'charger_manufacturers.add_manufacturer') | translate"
	[confirmBtnText]="'g.save' | translate"
	[closeBtnText]="'g.cancel' | translate"
	[closeOnConfirm]="false">
	<div class="form-group">
		<label for="manufacturerName">{{'charger_manufacturers.manufacturer' | translate}} <span class="text-danger">*</span></label>
		<input
			id="manufacturerName"
			class="form-control"
			[(ngModel)]="editedManufacturer.name"
			[maxlength]="chargerManufacturersService.maxNameLength"
		/>
	</div>
	<small class="text-danger" *ngIf="modalError">{{modalError}}</small>
</app-modal>

<app-modal
	#deleteManufacturerModal
	[title]="'g.confirm_action' | translate"
	[message]="'charger_manufacturers.delete_manufacturer_msg' | translate:{name: manufacturerToDelete?.name, count: manufacturerToDelete?.rules_count}">
</app-modal>

<app-modal
	#correctionModal
	[title]="(editedCorrection.id ? 'charger_manufacturers.edit_correction' : 'charger_manufacturers.add_correction') | translate"
	[confirmBtnText]="'g.save' | translate"
	[closeBtnText]="'g.cancel' | translate"
	[closeOnConfirm]="false">
	<div class="form-group">
		<label for="incorrectValue">{{'charger_manufacturers.incorrect_value' | translate}} <span class="text-danger">*</span></label>
		<input
			id="incorrectValue"
			class="form-control"
			[(ngModel)]="editedCorrection.incorrectValue"
			[maxlength]="chargerManufacturersService.maxNameLength"
		/>
	</div>
	<div class="form-group">
		<label for="correctedValue">{{'charger_manufacturers.corrected_value' | translate}} <span class="text-danger">*</span></label>
		<ng-select
			labelForId="correctedValue"
			[items]="manufacturers"
			bindLabel="name"
			bindValue="id"
			[(ngModel)]="editedCorrection.manufacturerId"
			[clearable]="false"
			[appendTo]="'body'">
		</ng-select>
	</div>
	<small class="text-danger" *ngIf="modalError">{{modalError}}</small>
</app-modal>

<app-modal
	#deleteCorrectionModal
	[title]="'g.confirm_action' | translate"
	[message]="'charger_manufacturers.delete_correction_msg' | translate:{value: correctionToDelete?.incorrect_value}">
</app-modal>
